import * as M from '@mantine/core';
import { IoIosInformationCircle } from 'react-icons/io';

import type { IServicePlan } from '../../../../shared/types/plan';
import { handleChangeLocaleTime } from '../../../../shared/utils/time';

interface IPropsTableUnit {
  data?: IServicePlan[];
  onClickPlan: (plan: IServicePlan) => () => void;
}

export default function TableUnit(props: IPropsTableUnit) {
  const { data, onClickPlan } = props;

  return (
    <M.Table.ScrollContainer minWidth={1080}>
      <M.Table withTableBorder highlightOnHover>
        <M.Table.Thead>
          <M.Table.Tr>
            <M.Table.Th>요금제명</M.Table.Th>
            <M.Table.Th>정상가(원)</M.Table.Th>
            <M.Table.Th>
              <M.Group gap={4} wrap="nowrap" justify="center">
                <span>할인가(원)</span>
                <M.Tooltip label="최종 표시금액">
                  <M.ActionIcon variant="subtle" color="gray" size="sm" aria-label="할인가 안내">
                    <IoIosInformationCircle size={16} />
                  </M.ActionIcon>
                </M.Tooltip>
              </M.Group>
            </M.Table.Th>
            <M.Table.Th>메모</M.Table.Th>
            <M.Table.Th>등록일</M.Table.Th>
            <M.Table.Th>최종 수정일</M.Table.Th>
            <M.Table.Th>최종수정 담당자</M.Table.Th>
          </M.Table.Tr>
        </M.Table.Thead>
        <M.Table.Tbody>
          {data?.map((plan) => {
            return (
              <M.Table.Tr key={plan.id} onClick={onClickPlan(plan)} style={{ cursor: 'pointer' }}>
                <M.Table.Td maw={200}>{plan.planName}</M.Table.Td>
                <M.Table.Td>
                  <M.NumberFormatter value={plan.regularPrice} thousandSeparator />
                </M.Table.Td>
                <M.Table.Td>
                  <M.NumberFormatter value={plan.discountPrice} thousandSeparator />
                </M.Table.Td>
                <M.Table.Td maw={260}>{plan.memo}</M.Table.Td>
                <M.Table.Td>{handleChangeLocaleTime(plan.regDt)}</M.Table.Td>
                <M.Table.Td>{handleChangeLocaleTime(plan.modDt)}</M.Table.Td>
                <M.Table.Td>{plan.modEmail}</M.Table.Td>
              </M.Table.Tr>
            );
          })}
        </M.Table.Tbody>
      </M.Table>
    </M.Table.ScrollContainer>
  );
}
